// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f2bb871c","836":"b5631359"}[chunkId] + ".chunk.js";
};